import SentryFullStory from '@sentry/fullstory';

export default function () {
    return [new SentryFullStory('demodesk')]
}